/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * All possible Precondition Failed problems.
 */
export type PreconditionFailedProblems =
    | Truvity.PreconditionFailedProblems.PreconditionFailed
    | Truvity.PreconditionFailedProblems.PreconditionFailedBlob
    | Truvity.PreconditionFailedProblems.PreconditionFailedResource;

export namespace PreconditionFailedProblems {
    export interface PreconditionFailed extends Truvity.ProblemPreconditionFailed {
        type: '/precondition-failed';
    }

    export interface PreconditionFailedBlob extends Truvity.ProblemBlobPreconditionFailed {
        type: '/precondition-failed/blob';
    }

    export interface PreconditionFailedResource extends Truvity.ProblemResourcePreconditionFailed {
        type: '/precondition-failed/resource';
    }
}
